import React from 'react';
import { Link, Box } from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const DailyLimitDecreaseMessageStyle = styled(Link)`
  color: ${({ theme }) => theme.warningColor};

  &:hover {
    color: ${({ theme }) => theme.warningColor};
  }
  &:visited {
    color: ${({ theme }) => theme.warningColor};
  }
`;

export const DailyLimitDecreaseMessage = () => {
  const { t } = useTranslation();

  return (
    <Box display="inline">
      <Trans
        i18nKey="validation_messages.daily_limit_decrese"
        components={{
          a: (
            <DailyLimitDecreaseMessageStyle
              href={t('validation_messages.daily_limit_decrese_link')}
              target="_blank"
              rel="noopener noreferrer"
            />
          )
        }}
      />
    </Box>
  );
};
